export default "__VITE_ASSET__e5afad00__"